import * as React from 'react';
import { Spinner } from '../../icons';
import theme from '../theme/default';

const FormLoadingSpinner: React.FC = () => (
  <Spinner color={theme.palette.primary.main} diameter={82} />
);

export default FormLoadingSpinner;
